import axios from "axios";
import React from "react";

import { SpinnerComponent } from "../../commonComponent/SpinnerComponent";
import ReCaptchaV3 from "../captcha/CaptchComponent";
import ReCaptchaButton from "../captcha/captcha-button";
import { APIKey, FormSectionElements, ProgramContainer } from "../../entities/formTemplateDataType";
import { getAppResponseData, getRoutingPageOnAppResponse, handleResponseData } from "../../response/AppResponseDataHanler";
import DataUtils, { catchFlowData } from "../../utilities/DataUtils";
import { getSectionBySequence } from "../../utilities/ElementUtils";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import SessionStorageService from "../../services/SessionStorageService";
import { checkSelectedService, checkUserProf, setBaseHeaders, setBasePayload } from "../../utilities/submitUtils";
import { copySimpleNonEmptyAttributes } from "../../utilities/URLUtils";
import Utils from "../../utilities/Utils";
import { SCRIPT_ENV } from "../../config/RuntimeConfig";

interface Props {
  field: FormSectionElements;
  title;
  isEng: boolean;
  callback,
  returnIndex?: number,
  callbackStepIndex?: (index: number, returnIndex?: number) => void;
}

interface State {
  isBusy: boolean
  pageError: boolean;
}

export class InquireAndRedirectComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isBusy: false,
      pageError: false,
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if (this.state.pageError) {
        this.setState({ pageError: false });
        const firstHeader = document.querySelector('#error-container') as HTMLDivElement;
        if (firstHeader) {
          firstHeader.focus();
      } 
    }
  }

  arrayToString = (_a) => {
    if (Array.isArray(_a)) {
      return _a.join(' ');
    } else {
      return [_a]
    }
  }

  handleSubmitError = () => {
    if (this.props.field.SubmitButton.apiErrorRedirectPage) {
      const sequence = Math.max(0, this.props.field.SubmitButton.apiErrorRedirectPage - 1);
      this.props.callbackStepIndex(sequence);
    } else {
      const page = getSectionBySequence(this.props.field, 10);
      if (page) {
        this.props.callbackStepIndex(Math.max(0, page.Sequence - 1));
      }
    }
  }

  handleButtonClick = async (captchaToken?: string) => {
    const field = this.props.field;
    let programContainer = field.parent.parent.parent as ProgramContainer;
    if (field.Api) {
      const api = field.Api;
      const token = SessionStorageService.getAuthToken(programContainer.AuthRequired) ?? programContainer.Profile?.token;
      const apiKey: APIKey = (field.ApiKeyKey && field.ApiKeyValue) ? {key: field.ApiKeyKey, value: field.ApiKeyValue} : null;
      const headers = setBaseHeaders('application/json', token, apiKey);

      let entity = DataUtils.collectFormValue(programContainer);
      entity = setBasePayload(entity, this.props.isEng ? "EN" : "FR", captchaToken);
      entity = checkUserProf(entity, programContainer.Profile);
      entity = checkSelectedService(entity);

      let response: any;

      try {
        this.setState({ isBusy: true });
        switch (field.SubmissionMethod) {
          case "post":
            response = await axios.post(api, entity, { headers: headers });
            break;
          case "get":
            const queryParams = copySimpleNonEmptyAttributes(entity, {});
            const configs = {
              ...{ headers },  // Headers
              ...queryParams ? { params: queryParams } : undefined,  // Query params
            };
            response = await axios.get(api, configs);
            break;
          case "put":
            response = await axios.put(api, entity, { headers: headers });
            break;
        }
        
        if (response.status >= 400) {
          this.handleSubmitError();
          return;
        }
      } catch (ex) {
        console.log(ex);
        this.handleSubmitError();
        return;
      } finally {
        this.setState({ isBusy: false });
      }

      if (!response) {
        this.handleSubmitError();
        return;
      }
    
     let currentEntity = getAppResponseData(field, response); 
     if (!currentEntity) {
        const fieldFound = field.findFieldByName('Record__not__found');
        if (fieldFound) {
          fieldFound.Visible = true;
        }
        this.props.callback(programContainer);
        return;
      }

      const pageSeq = getRoutingPageOnAppResponse( field, response);
      if (pageSeq > 0) {
        this.props.callbackStepIndex(pageSeq - 1);
        return;
      }

      const paymentSiteUrl = handleResponseData(field, entity, currentEntity);
      // this.props.callback(programContainer);
      if (paymentSiteUrl) {
        catchFlowData(programContainer, this.props.isEng ? 'EN' : 'FR');
        window.location.href = paymentSiteUrl;
      }
    }

    FormValidationUtils.runJavascript(field);

    const currentSection= this.props.field.parent.parent;
    const root =currentSection.parent;
    const gaTrackingId = root.GATrackingID;
    
    // if(gaTrackingId){
    //       gaEvent({action: 'click', category: 'Continue', label: this.props.isEng ? currentSection.ENUTitle : currentSection.FRATitle}, gaTrackingId);
    // }

    this.props.callback(root);
  }

  render() {
    let field = this.props.field;

    if (!field.Visible) return null;

    let controlArray = [];
    let title = this.props.isEng ? this.props.field.ENUTitle : this.props.field.FRATitle;

    if (field.InitScript && Utils.isNotNullOrEmpty(field.InitScript)) {
      const customJSFunc = eval(`(${field.InitScript})`);
      try {
        customJSFunc(field, SCRIPT_ENV);
      } catch (ex) {
        console.log(ex);
      }
    }

    const ClassName = "ontario-button " + this.arrayToString(this.props.field.ClassName);
    controlArray.push(
      <>
        <div style={{textAlign: 'left', display: `${field.inlineStyling ? 'inline-block' : 'block'}`}} key={"button_" + field.parent.Sequence + "_" + field.Id}>
          {!field.Recaptcha && !field.SubmitButton?.enableRecaptcha && (
            <button className={ClassName} 
              id={`button_${field.parent.Sequence}_${field.Id}`}
              title={this.props.isEng ? field.ENUTitle : field.FRATitle}
              onClick={(e) => this.handleButtonClick()}>
              {title}
            </button>
          )}
          {(field.Recaptcha || field.SubmitButton?.enableRecaptcha) && (
            <ReCaptchaV3 lang={this.props.isEng ? 'en' : 'fr'}>
              <ReCaptchaButton key={"recaptchbutton"}
                  title={title}
                  action={field.Recaptcha.action || 'submitAction'}
                  buttonHandler={this.handleButtonClick}>
                {title}
              </ReCaptchaButton>
            </ReCaptchaV3>
          )}
          <div>
            <SpinnerComponent isBusy={this.state.isBusy} />
          </div>
        </div>
      </>
    );

    return controlArray;
  }
}